import React from "react";
import { Link } from "react-router-dom";
import { Api } from "../app-controller.js";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ShowForm from "../components/electronic-prescription/ShowForm";
import classnames from "classnames";
import Swal from "sweetalert2";
import Select from "react-select";
import printJS from "print-js";

// ESTILOS CSS PARA LOS INPUTS IMPORTADOS
const colourStyles = {
  input: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#686666",
    color: "#fff",
  }),
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  noOptionsMessage: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
      backgroundColor: "#000",
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#1c4d85" : isFocused ? "#1978E2" : "#000",
      color: "#FFF",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "#1978E2",
      },
    };
  },
};

class Visits extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      previa: false,
      previa_url: "",
      modalState: false,
      working: true,
      workingModal: true,
      observationModalOpen: false,
      observacion: "",
      toggle: false,
      paginaActual: 0,
      paginaActual_vi: 0,
      paginas: 0,
      especie: "",
      paginas_vi: 0,
      registros: 0,
      registros_vi: 0,
      cat_especies: Api.loadCatalogue("cat_especie"),
      recetas_electronicas: [],
      receta_electronica: "",
      activeTab: "1",
      nivelUsuario: localStorage.nivel_actual,
      buscar: {},
      collapse: [
        {
          id: 1,
          collapse: true,
        },
        {
          id: 2,
          collapse: false,
        },
      ],
    };
  }

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  toggleCollapse = (index) => {
    var newArray = [];
    for (let collapseObj of this.state.collapse) {
      if (collapseObj.id === index) {
        collapseObj.collapse = !collapseObj.collapse;
      } else {
        collapseObj.collapse = false;
      }
      newArray.push(collapseObj);
    }

    this.setState({ collapse: newArray });
  };

  componentDidMount() {
    // si el usuario no es nivel medico veterinario ipsa, drycip o cliente redireccionamos a home
    if (!["1", "3", "7"].includes(this.state.nivelUsuario)) {
      window.location.href = "/";
    }

    this.setState({ buscar: this.search });
    this.setListaRecetasElectronicasPage(1);
  }

  // Inicia logica que controla la pestaña de regente (grid y detalle)
  search = [];

  handleSearch = (evt, obj) => {
    if (obj && obj.name === "especie") {
      evt ? (this.search[obj.name] = evt.id) : delete this.search[obj.name];
    } else {
      // Si el obj.target.name pertenece a un input type text aplicamos la funcion toUpperCase()
      [
        "folio",
        "producto",
        "fabricante",
        "nombre_propietario_animal",
        "fecha_emision",
        "fecha_vencimiento",
        "medico_veterinario",
      ].includes(evt.target.name)
        ? (this.search[evt.target.name] = evt.target.value.toUpperCase())
        : (this.search[evt.target.name] = evt.target.value);
    }

    this.setState({ buscar: this.search });
  };

  // cleanSearch = () => {
  //   let search = this.state.buscar;

  //   for (const prop in search) {
  //     delete search[prop];
  //     document.getElementById(prop).value = "";
  //   }

  //   this.setState({ buscar: search });
  //   this.setListaRecetasElectronicasPage(1);
  // };

  //Funcion para cambiar de pagina en el grid de regente
  setListaRecetasElectronicasPage = (page) => {
    this.setState({ workingGrid: true });
    let search = this.state.buscar;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch(
      "app/getElectronicPrescriptionList?page=" +
        page +
        src +
        "&nivelUsuario=" +
        this.state.nivelUsuario
    ).then((re) => {
      this.setState({
        recetas_electronicas: re.data,
        paginas: re.last_page,
        registros: re.total,
        paginaActual: re.current_page,
        workingGrid: false,
      });
    });
  };

  handleListaRecetasElectronicasPage = (e) => {
    this.setListaRecetasElectronicasPage(e.target.value);
  };

  updatePrescriptionPrint = (id, nombrePDF) => {
    let fileName = nombrePDF.replace("/", "-");
    Api.loading(true);
    let receta = {
      id: id,
      nivelUsuario: this.state.nivelUsuario,
    };

    Api.fetch("app/updatePrescriptionPrint", receta, "PUT")
      .then((data) => {
        if (data) {
          this.setState({
            receta_electronica: data,
          });
        }
      })
      .then((res) => {
        Api.loading(false);
        printJS({
          printable: Api.url + `app/receta_electronica/?id=${id}`,
          type: "pdf",
          documentTitle: fileName,
          onPrintDialogClose: () => {
            if (this.state.nivelUsuario === "1") {
              window.location.href = "/recetas-electronicas/expedidas";
            }
          },
        });
      });
  };

  handleModalCloseBtn = (evt) => {
    evt.preventDefault();

    this.setState({
      workingModal: true,
      receta_electronica: "",
      modalState: false,
    });
  };

  openPrescriptModal = (evt) => {
    this.setState({ modalState: true });
    //buscamos la receta
    Api.fetch("app/getElectronicPrescription?id=" + evt.target.id)
      .then((data) => {
        if (data) {
          this.setState({
            receta_electronica: data,
          });
        }
      })
      .then((res) => {
        this.setState({ workingModal: false });
      });
  };

  handleCloseBtn = (evt) => {
    this.setState({ previa: false, receta_electronica: "" });
    if (this.state.nivelUsuario === "1") {
      window.location.reload();
    }
  };

  handleBajaRecetaBtn = (evt) => {
    Swal.fire({
      input: "textarea",
      title: "MOTIVO DE BAJA",
      inputPlaceholder: "Ingrese motivo de baja",
      showCancelButton: false,
      showDenyButton: true,
      denyButtonColor: "red",
      confirmButtonColor: "#4CD964",
      inputValidator: (value) => {
        return !value && "Debe ingresar el motivo de baja.";
      },
      denyButtonText: "Regresar",
      confirmButtonText: "Continuar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        let obj = {
          id: evt.target.id,
          observacion: result.value.toUpperCase(),
        };
        this.disablePrescription(obj);
      }
    });
  };

  disablePrescription = (obj) => {
    Api.loading(true);
    Api.fetch("app/disableElectronicPrescription", obj, "PUT").then((res) => {
      Api.loading(false);
      Swal.fire({
        icon: "success",
        title: "¡La receta ha sido dada de baja!",
        timer: 3000,
      }).then(() => {
        window.location.href = "/recetas-electronicas/expedidas";
      });
    });
  };

  printPrescriptionPDF = (receta) => {
    if (this.state.nivelUsuario === "1") {
      Swal.fire({
        icon: "warning",
        title: "Advertencia",
        text: "La receta electrónica sólo puede imprimirse una vez, ¿Desea continuar?",
        showDenyButton: true,
        denyButtonColor: "red",
        confirmButtonColor: "#4CD964",
        showCancelButton: false,
        confirmButtonText: `Abrir`,
        denyButtonText: `Regresar`,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.updatePrescriptionPrint(receta.id, receta.folio_receta);
        }
      });
    } else {
      this.updatePrescriptionPrint(receta.id, receta.folio_receta);
    }
  };

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/recetas-electronicas/expedidas">
              Recetas electrónicas
            </Link>
          </li>
          <li className="breadcrumb-item active">Expedidas</li>
        </ol>
        <h1 className="page-header">Recetas expedidas</h1>
        <div className="row">
          <div className="col-xl-12">
            <Nav tabs={true}>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "1",
                  })}
                  onClick={() => {
                    this.toggleTab("1");
                  }}
                >
                  <span className="d-sm-none">
                    {this.state.nivelUsuario === "3"
                      ? "RECETAS ELECTRÓNICAS"
                      : "RECETAS EXPEDIDAS"}
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros}
                    </span>
                  </span>
                  <span className="d-sm-block d-none">
                    {this.state.nivelUsuario === "3"
                      ? "RECETAS ELECTRÓNICAS"
                      : "RECETAS EXPEDIDAS"}
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros}
                    </span>
                  </span>
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                <div className="table-responsive">
                  <fieldset>
                    <legend>Buscar</legend>

                    <div className="row">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="folio">Folio:</label>
                          <div className="input-group">
                            <input
                              id="folio"
                              name="folio"
                              placeholder="Ingrese folio"
                              onChange={this.handleSearch}
                              className="form-control"
                              type="text"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="producto">Producto:</label>
                          <div className="input-group">
                            <input
                              id="producto"
                              name="producto"
                              onChange={this.handleSearch}
                              placeholder="Ingrese nombre de producto"
                              className="form-control"
                              type="text"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="fabricante">Fabricante:</label>
                          <div className="input-group">
                            <input
                              id="fabricante"
                              name="fabricante"
                              onChange={this.handleSearch}
                              placeholder="Ingrese nombre de fabricante"
                              className="form-control"
                              type="text"
                            />
                          </div>
                        </div>
                      </div>

                      {/* <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="especie">Especie:</label>
                          <Select
                            id="especie"
                            styles={colourStyles}
                            placeholder="Seleccione"
                            name="especie"
                            isClearable={true}
                            onChange={this.handleSearch}
                            theme="neutral40"
                            options={this.state.cat_especies}
                            getOptionLabel={(especie) =>
                              especie.descripcion.toUpperCase()
                            }
                            getOptionValue={(especie) => especie.id}
                            noOptionsMessage={() => "No se encontraron especies"}
                          />
                        </div>
                      </div> */}
                    </div>

                    <div className="row">
                      <div
                        className={
                          ["1", "7"].includes(this.state.nivelUsuario)
                            ? "col-lg-3"
                            : "col-lg-6"
                        }
                      >
                        <div className="form-group">
                          <label htmlFor="nombre_propietario_animal">
                            Propietario animal:
                          </label>
                          <div className="input-group">
                            <input
                              id="nombre_propietario_animal"
                              name="nombre_propietario_animal"
                              onChange={this.handleSearch}
                              placeholder="Ingrese nombre del propietario"
                              className="form-control"
                              type="text"
                            />
                          </div>
                        </div>
                      </div>

                      {this.state.nivelUsuario === "3" ? (
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="medico_veterinario">
                              Nombre de médico veterinario:
                            </label>
                            <div className="input-group">
                              <input
                                id="medico_veterinario"
                                name="medico_veterinario"
                                onChange={this.handleSearch}
                                placeholder="Ingrese nombre de médico veterinario"
                                className="form-control"
                                type="text"
                              />
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {["1", "7"].includes(this.state.nivelUsuario) ? (
                        <>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label htmlFor="estatus">Estado:</label>
                              <select
                                name="estatus"
                                onChange={this.handleSearch}
                                id="estatus"
                                className="form-control"
                              >
                                <option value="">Seleccione estatus</option>
                                <option value="1">BAJA</option>
                                <option value="2">EXPEDIDA</option>
                                <option value="3">SURTIDA</option>
                                <option value="4">VENCIDA</option>
                              </select>
                            </div>
                          </div>

                          <div className={"col-lg-2"}>
                            <div className="form-group">
                              <label htmlFor="fecha_emision">
                                Fecha de emisión:
                              </label>
                              <div className="input-group">
                                <input
                                  type="date"
                                  name="fecha_emision"
                                  onChange={this.handleSearch}
                                  id="fecha_emision"
                                  className="form-control"
                                  placeholder="Fecha"
                                />
                              </div>
                            </div>
                          </div>

                          <div className={"col-lg-2"}>
                            <div className="form-group">
                              <label htmlFor="fecha_vencimiento">
                                Fecha de vencimiento:
                              </label>
                              <div className="input-group">
                                <input
                                  type="date"
                                  name="fecha_vencimiento"
                                  onChange={this.handleSearch}
                                  id="fecha_vencimiento"
                                  className="form-control"
                                  placeholder="Fecha"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-2">
                            <div className="form-group">
                              <label htmlFor="search">&nbsp;</label>
                              <div className="input-group">
                                <button
                                  type="button"
                                  className="btn btn-orange w-100"
                                  title="Buscar"
                                  onClick={() =>
                                    this.setListaRecetasElectronicasPage(1)
                                  }
                                >
                                  <i className="fa fa-search"></i> Buscar
                                </button>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : null}

                      {/* <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="search">&nbsp;</label>
                          <div className="input-group">
                            <button
                              type="button"
                              className="btn btn-blue w-100"
                              title="Limpiar"
                              onClick={this.cleanSearch}
                            >
                              <i className="fas fa-trash-alt"></i> Limpiar
                            </button>
                          </div>
                        </div>
                      </div> */}
                    </div>

                    {this.state.nivelUsuario === "3" ? (
                      <div className="row">
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label htmlFor="estatus">Estado:</label>
                            <select
                              name="estatus"
                              id="estatus"
                              onChange={this.handleSearch}
                              className="form-control"
                            >
                              <option value="">Seleccione estatus</option>
                              <option value="1">BAJA</option>
                              <option value="2">EXPEDIDA</option>
                              <option value="3">SURTIDA</option>
                              <option value="4">VENCIDA</option>
                            </select>
                          </div>
                        </div>

                        <div className={"col-lg-3"}>
                          <div className="form-group">
                            <label htmlFor="fecha_emision">
                              Fecha de emisión:
                            </label>
                            <div className="input-group">
                              <input
                                type="date"
                                name="fecha_emision"
                                onChange={this.handleSearch}
                                id="fecha_emision"
                                className="form-control"
                                placeholder="Fecha"
                              />
                            </div>
                          </div>
                        </div>

                        <div className={"col-lg-3"}>
                          <div className="form-group">
                            <label htmlFor="fecha_vencimiento">
                              Fecha de vencimiento:
                            </label>
                            <div className="input-group">
                              <input
                                type="date"
                                name="fecha_vencimiento"
                                onChange={this.handleSearch}
                                id="fecha_vencimiento"
                                className="form-control"
                                placeholder="Fecha"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-2">
                          <div className="form-group">
                            <label htmlFor="search">&nbsp;</label>
                            <div className="input-group">
                              <button
                                type="button"
                                className="btn btn-orange w-100"
                                title="Buscar"
                                onClick={() =>
                                  this.setListaRecetasElectronicasPage(1)
                                }
                              >
                                <i className="fa fa-search"></i> Buscar
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </fieldset>
                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th className="text-center">Folio</th>
                        {this.state.nivelUsuario === "3" ? (
                          <th className="text-center">Médico veterinario</th>
                        ) : null}
                        <th className="text-center">Producto</th>
                        <th className="text-center">Especie</th>
                        <th className="text-center">Fabricante</th>
                        <th className="text-center">Fecha emisión</th>
                        <th className="text-center">Fecha vencimiento</th>
                        <th className="text-center">Propietario animal</th>
                        {/* {this.state.nivelUsuario === "1" ? (
                          <th className="text-center">Estado</th>
                        ) : null} */}
                        <th className="text-center">Estado</th>
                        <th className="text-center" width="10%">
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody className={this.state.workingGrid ? "hide" : ""}>
                      {this.state.recetas_electronicas &&
                      Object.keys(this.state.recetas_electronicas).length >
                        0 ? (
                        this.state.recetas_electronicas.map((re) => (
                          <tr
                            key={re.id}
                            className={
                              re.dias > 15 && re.estatus === "En espera"
                                ? "alerta"
                                : ""
                            }
                          >
                            <td className="text-center">{re.folio_receta}</td>
                            {this.state.nivelUsuario === "3" ? (
                              <td className="text-center">{`${re.nombres} ${re.apellido_paterno} ${re.apellido_materno}`}</td>
                            ) : null}

                            <td className="text-center">
                              {re.producto_nombre_comercial}
                            </td>
                            <td className="text-center">
                              {re.especie_texto.toUpperCase()}
                            </td>
                            <td className="text-center">
                              {re.nombre_fabricante.toUpperCase()}
                            </td>
                            <td className="text-center">
                              {re.fecha_emision_fmt}
                            </td>
                            <td className="text-center">
                              {re.fecha_vencimiento_fmt}
                            </td>
                            <td className="text-center">
                              {re.nombre_propietario_animal}
                            </td>
                            {/* 
                            {this.state.nivelUsuario === "1" ? (
                              <td className="text-center">
                                {re.status === "1" ? "ACTIVA" : "NO ACTIVA"}
                              </td>
                            ) : null} */}

                            <td className="text-center">
                              {re.surtida === "1"
                                ? "SURTIDA"
                                : re.no_vencida === "1" && re.status === "1"
                                ? "EXPEDIDA"
                                : re.no_vencida === "0"
                                ? "VENCIDA"
                                : re.status === "0"
                                ? "BAJA"
                                : "N/A"}
                            </td>

                            <td className="text-center">
                              <div className="btn-group">
                                <button
                                  onClick={this.openPrescriptModal}
                                  id={re.id}
                                  title="Ver receta"
                                  className="btn btn-warning"
                                >
                                  <i id={re.id} className="fas fa-eye"></i>
                                </button>
                                {/* nivel cliente y medico veterinario ipsa */}
                                {["1", "7"].includes(
                                  this.state.nivelUsuario
                                ) ? (
                                  re.impresiones < 1 &&
                                  re.no_vencida === "1" &&
                                  re.status === "1" ? (
                                    <button
                                      onClick={() =>
                                        this.printPrescriptionPDF(re)
                                      }
                                      id={re.id}
                                      title="Imprimir receta"
                                      className="btn btn-blue"
                                    >
                                      <i
                                        id={re.id}
                                        className="fas fa-print"
                                      ></i>
                                    </button>
                                  ) : null
                                ) : null}

                                {/* nivel drycip */}
                                {this.state.nivelUsuario === "3" ? (
                                  <>
                                    <button
                                      onClick={() =>
                                        this.printPrescriptionPDF(re)
                                      }
                                      id={re.id}
                                      title="Imprimir receta"
                                      className="btn btn-primary"
                                    >
                                      <i
                                        id={re.id}
                                        className="fas fa-print"
                                      ></i>
                                    </button>
                                    {re.status === "1" &&
                                    re.no_vencida === "1" &&
                                    re.surtida !== "1" ? (
                                      <button
                                        onClick={this.handleBajaRecetaBtn}
                                        id={re.id}
                                        title="Dar de baja receta"
                                        className="btn btn-danger"
                                      >
                                        <i
                                          id={re.id}
                                          className="fas fa-trash-alt"
                                        ></i>
                                      </button>
                                    ) : null}
                                  </>
                                ) : null}
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="10" className="text-center">
                            <b>No se encontraron registros</b>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className={this.state.workingGrid ? "m-10" : "hide"}>
                    <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                      CARGANDO INFORMACIÓN
                    </div>
                  </div>
                  <hr />
                  <div className="d-flex align-items-center justify-content-center">
                    <ul className="pagination mb-0">
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.setListaRecetasElectronicasPage(1);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-left"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (this.state.paginaActual - 1 > 0) {
                              this.setListaRecetasElectronicasPage(
                                this.state.paginaActual - 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-left"></i>
                        </button>
                      </li>
                      <li className="page-item d-flex align-items-center px-2">
                        <div>
                          Página
                          <strong>
                            {" "}
                            {this.state.paginaActual} de {this.state.paginas}
                          </strong>
                        </div>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (
                              this.state.paginas >=
                              this.state.paginaActual + 1
                            ) {
                              this.setListaRecetasElectronicasPage(
                                this.state.paginaActual + 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-right"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.setListaRecetasElectronicasPage(
                              this.state.paginas
                            );
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-right"></i>
                        </button>
                      </li>
                    </ul>
                    <div className="ml-3 mr-1">Página:</div>
                    <div className="width-50 mx-2">
                      <input
                        className="form-control"
                        onChange={this.handleListaRecetasElectronicasPage}
                        type="number"
                        min="1"
                        max={this.state.paginas}
                        value={this.state.paginaActual}
                      />
                    </div>
                    <div></div>
                  </div>
                </div>
              </TabPane>
            </TabContent>
            {/* <div
              className={this.state.previa ? "previa" : "hide"}
              onContextMenu={(e) => e.preventDefault()}
            >
              <iframe
                title="Vista previa"
                className="rounded"
                src={this.state.previa_url}
                loading="eager"
              ></iframe>
              <center>
                <div className="btn-group">
                  <button onClick={this.handleCloseBtn} className="btn btn-white">
                    Regresar
                  </button>
                  <a
                    className="btn btn-primary"
                    href={this.state.previa_url + "&download=1"}
                    download="download"
                  >
                    Descargar
                  </a>
                </div>
              </center>
            </div> */}
            <Modal
              isOpen={this.state.modalState}
              tabIndex="-1"
              style={{
                maxWidth: "100%",
                width: "85%",
              }}
            >
              <ModalHeader
                width="100%"
                toggle={() => {
                  this.setState({
                    modalState: false,
                    workingModal: true,
                    receta_electronica: "",
                  });
                }}
                className="text-center"
              >
                {this.state.receta_electronica.folio_receta}
              </ModalHeader>
              <ModalBody>
                <form id="electronic-prescription">
                  <ShowForm
                    receta_electronica={this.state.receta_electronica}
                    workingModal={this.state.workingModal}
                  />
                </form>
              </ModalBody>
              <ModalFooter>
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <button
                        onClick={this.handleModalCloseBtn}
                        className="btn btn-danger float-right"
                      >
                        Regresar
                      </button>
                    </div>
                  </div>
                </div>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

export default Visits;
